import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-12de4320"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "Dashboard-Jobs-Card__Background" }, null, -1))
const _hoisted_2 = { class: "Dashboard-Jobs-Card__Inner" }
const _hoisted_3 = { class: "text-lg" }
const _hoisted_4 = { class: "text-sm" }
const _hoisted_5 = { class: "text-sm" }
const _hoisted_6 = { class: "Dashboard-Jobs-Card_recruiter" }
const _hoisted_7 = {
  key: 0,
  class: "round"
}
const _hoisted_8 = ["src", "alt"]
const _hoisted_9 = { class: "text-sm" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createBlock(_component_RouterLink, {
    to: `/job-board/${_ctx.job.slug}`,
    class: "Dashboard-Jobs-Card"
  }, {
    default: _withCtx(() => [
      _hoisted_1,
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.job.title), 1),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.job.restaurant), 1),
        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.job.location), 1),
        _createElementVNode("div", _hoisted_6, [
          (_ctx.job.recruiter_img)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("img", {
                  src: _ctx.job.recruiter_img,
                  alt: _ctx.job.recruiter
                }, null, 8, _hoisted_8)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_9, _toDisplayString(_ctx.$t("dashboard.posted_by")) + " " + _toDisplayString(_ctx.job.recruiter), 1)
        ])
      ])
    ]),
    _: 1
  }, 8, ["to"]))
}